import { Dispatch, FC, SetStateAction } from "react";

import { useMediaQuery } from "context/media/MediaContext";

import Button from "../../BaseComponents/Button";
import Modal from "../../BaseComponents/Modal";
import { Col, Row, Seperator } from "../../BaseComponents/Flex";

interface PasswordBlockModalProps {
  title?: string;
  message?: string;
  acceptButtonText?: string;
  setIsOpen: Dispatch<SetStateAction<boolean>>;
  rejectButtonText?: string;
}

const PasswordBlockModal: FC<PasswordBlockModalProps> = ({
  title,
  message,
  acceptButtonText,
  setIsOpen,
}) => {
  const { isMobile } = useMediaQuery();

  const onAcceptClick = () => {
    setIsOpen(false);
    window.location.reload();
  };

  return (
    <Modal
      info={message}
      maxWidth={450}
      setIsOpen={setIsOpen}
      title={title}
      isClosable={true}
    >
      <Row justifyContent='center' isResponsive noMargin>
        <Col size={0.3}>
          <Button onClick={onAcceptClick} text={acceptButtonText} />
        </Col>

        <Seperator marginRight={20} marginTop={isMobile ? 10 : 0} />
      </Row>
    </Modal>
  );
};

export default PasswordBlockModal;
